import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { IconComponent } from '../../atoms/icon/icon.component';
import MenuItem from '../../../shared/interfaces/menuItems.interface';
import { Colors } from '../../../shared/enums/shared.enums';

@Component({
  selector: 'hdi-dropdown-nav',
  standalone: true,
  imports: [CommonModule, RouterModule, IconComponent],
  templateUrl: './dropdown-nav.component.html',
  styleUrls: ['./dropdown-nav.component.scss'],
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class DropdownNavComponent implements OnInit {
  @Input() menuItem: MenuItem;
  @Input() isActiveChild: boolean = false;
  @Input() isActiveGrandChild: boolean = false;
  @ViewChild('chevronIcon') chevronIcon!: ElementRef;
  @Output() closeMenu: EventEmitter<void> = new EventEmitter<void>();
  isLargeScreen: boolean = false;

  readonly Colors = Colors;

  public isOpen = false;

  private isParentNavigation = false;

  constructor(
    private router: Router,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.menuItem = {
      url: '',
      title: '',
    };
  }

  toggle(event: Event) {
    if (
      this.menuItem.subitems &&
      !this.isParentNavigation &&
      this.menuItem.subitems.length
    ) {
      event.stopPropagation();
      this.isOpen = !this.isOpen;
    } else {
      this.navigateTo(this.menuItem.url, event);
    }
  }
  @HostListener('window:resize')
  onResize(): void {
    this.checkViewportWidth();
  }

  ngOnInit(): void {
    this.checkViewportWidth();
  }

  checkViewportWidth(): void {
    this.isLargeScreen = window.innerWidth >= 1200;
  }
  navigateTo(url: string, event: Event) {
    event.preventDefault();
    if (this.menuItem.subitems) {
      this.isParentNavigation = true;
    }
    this.router.navigateByUrl(url);
    this.document.defaultView?.scrollTo({ top: 0 });
    this.closeMenu.emit();
  }

  getDropdownIcon(menuItem: MenuItem): string {
    if (menuItem.subitems && menuItem.subitems.length > 0) {
      return 'chevron-down';
    } else {
      return 'chevron-right';
    }
  }
}
